import { useContext } from 'react';

import { ReactComponent as LevelsIcon } from 'assets/icons/levels.svg';
import { ReactComponent as LocalsIcon } from 'assets/icons/locals.svg';
import { THREE_D_OVERLAY_OPTIONS } from 'constants/options';
import { TranslationContext } from 'context/translationContext';

import styles from './styles.module.scss';
import { Props } from './types';

const OverlayControl = ({ selected, onChange, isOverlayVisible }: Props) => {
  const { t } = useContext(TranslationContext);

  const handleChange = (newValue: string) => {
    if (newValue !== selected) {
      onChange('selectedOverlay', newValue);
    }
  };

  return (
    <div
      className={[styles.container, !isOverlayVisible && styles.hidden].join(
        ' ',
      )}
    >
      {THREE_D_OVERLAY_OPTIONS(t).map(option => (
        <div key={option.value} className={styles.wrapper}>
          <button
            onClick={() => handleChange(option.value)}
            className={[
              styles.label,
              option.value !== selected && styles.blurred,
            ].join(' ')}
            data-tip={option.label}
          >
            {option.label === 'Mieszkania' ? <LocalsIcon /> : <LevelsIcon />}
          </button>
        </div>
      ))}
    </div>
  );
};

export default OverlayControl;
